import { Flex } from '@chakra-ui/react'

import Footer from '~components/Footer'
import { Navbar } from '~components/Navbar'

export interface PageLayoutProps {
  children: React.ReactNode
  showNavBar?: boolean
}
export const PageLayout = ({
  children,
  showNavBar = true,
}: PageLayoutProps) => {
  return (
    <Flex flexDir="column" minH="calc(100vh - 32px)">
      {/* 32px is the height of the restricted govt masthead */}
      {showNavBar && <Navbar />}
      <div className="flex-1">{children}</div>
      <div className="w-full">
        <Footer />
      </div>
    </Flex>
  )
}
